import storage from '../storage'
import axios from 'axios'

window.axios = axios;

// En desarrollo, usar /api como baseURL para que el proxy intercepte
// En producción, usar la URL completa del backend
const isDevelopment = process.env.NODE_ENV === 'development'

// Debug: logs temporales para verificar variables de entorno
console.log('🔍 Debug ENV:');
console.log('- NODE_ENV:', process.env.NODE_ENV);
console.log('- VUE_APP_ENV_HOST:', process.env.VUE_APP_ENV_HOST);
console.log('- VUE_APP_ENV_AMBIENT:', process.env.VUE_APP_ENV_AMBIENT);

if (isDevelopment) {
    // En desarrollo: usar /api para que el proxy intercepte
    axios.defaults.baseURL = '/api'
} else {
    // En producción: usar la URL completa, asegurándose de que termine en /api
    const host = process.env.VUE_APP_ENV_HOST || ''
    
    // Fallback: Si no hay host definido, inferir del dominio actual
    if (!host) {
        const currentDomain = window.location.hostname
        console.warn('⚠️ VUE_APP_ENV_HOST no está definido, usando fallback basado en dominio:', currentDomain)
        
        if (currentDomain.includes('qa.carnaval') || currentDomain.includes('preview')) {
            axios.defaults.baseURL = 'https://ws-qa.carnaval.rbsoft.com.ar/api'
        } else {
            axios.defaults.baseURL = 'https://ws.carnaval.rbsoft.com.ar/api'
        }
    } else {
        axios.defaults.baseURL = host.endsWith('/api') ? host : `${host}/api`
    }
}

console.log('- Axios baseURL configurado:', axios.defaults.baseURL);

// Configurar axios para enviar credentials (mejora compatibilidad CORS)
axios.defaults.withCredentials = true;

if(storage.state.isAuthenticated){
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + storage.state.token;
}